import { render, staticRenderFns } from "./ViewUserModal.vue?vue&type=template&id=8534c392&scoped=true&"
import script from "./ViewUserModal.vue?vue&type=script&lang=js&"
export * from "./ViewUserModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewUserModal.vue?vue&type=style&index=0&id=8534c392&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8534c392",
  null
  
)

export default component.exports